export function getDataSourceMethodReturnSchema(designer, renderer, dataSourceId, methodName) {
    const source = designer.rootPagelet.xySources.find((i) => i.id === dataSourceId);
    const methodConfig = source.methods.find((item) => item.id === methodName);
    if (methodConfig?.type !== 'form') {
        return undefined;
    }
    const dataSourceData = renderer.data[dataSourceId]?.collection?.collectionData;
    return dataSourceData?.stateSchema?.methods?.find((item) => item.id === methodName)?.returnValue;
}
